import { jsPDF } from 'jspdf';

const LEFTMARGIN = 15;
const fontName = 'Helvetica';

const logoImgData =
    'data:image/png;base64,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';

const SUMMARYNOTAVAILABLE = 'Summary is not available';

// Load the Tahoma font
// const fontTahoma = {
//     encoding: 'WinAnsiEncoding',
//     fontName: 'Tahoma',
//     mimeType: 'application/x-font-ttf',
//     fontStyle: 'normal',
//     fontWeight: 'normal',
// };

// doc.addFont('Tahoma.ttf', 'Tahoma', 'normal');
// doc.setFont('Tahoma'); // Set the font
// doc.setFontSize(12); // Set the font size

export class PDFDocumentCreator {
    // tslint:disable-next-line: typedef

    public create([gyanSummary, allTopicArticles, topicLevelMultidocSummary]: any) {
        let topicListBulleted: any = [];
        gyanSummary.topics.map((topic: any) => {
            topicListBulleted = this.topicSummary(topic, 0, topicListBulleted, false);
        });

        let topicListBulletedWithArticleCount: any = [];
        gyanSummary.topics.map((topic: any) => {
            topicListBulletedWithArticleCount = this.topicSummary(topic, 0, topicListBulletedWithArticleCount, true);
        });

        console.log('topicListBulleted', topicListBulleted);
        console.log('topicListBulletedWithArticleCount', topicListBulletedWithArticleCount);

        let pages: any = [];
        const topicPages = this.topicCard(gyanSummary.rootTopic, allTopicArticles, topicLevelMultidocSummary, [], 0, {}, 'article', 'main');
        //pages.push(topicPages);
        pages = [...pages, ...topicPages];

        const additionalTopicPages = this.topicCard(gyanSummary.rootTopic, allTopicArticles, topicLevelMultidocSummary, [], 0, {}, 'article', 'additional');

        if (additionalTopicPages.length > 0) {
            pages.push({
                text: 'Additional Articles',
                alignment: 'LEFT',
                style: 'addheadingMain',
                pageBreakBefore: true,
                spacing: {
                    after: 600,
                },
            });
        }
        pages = [...pages, ...additionalTopicPages];

        //console.log('pages', JSON.stringify(pages));

        const doc = new jsPDF();
        // Global variables for page dimensions
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;

        // Global variable for total number of pages
        let totalPages = 3;

        // Add first page (title and date)
        this.addHeader(doc, pageWidth, pageHeight);

        this.addFirstPageContent(doc, gyanSummary, pageWidth, pageHeight);

        // Add remaining pages with dynamic content
        doc.addPage();
        this.addHeader(doc, pageWidth, pageHeight);
        const contentItem = this.addContent(doc, pages, pageWidth, pageHeight, totalPages); // Pass your array of objects containing dynamic content
        totalPages = contentItem.totalPages;
        const headingAnchorPoints = contentItem.headingAnchorPoints;

        const tocPageCunt = this.addTableOfContents(doc, pages, pageWidth, pageHeight, headingAnchorPoints);
        // console.log('tocPageCunt', tocPageCunt);
        // console.log('totalPages', totalPages);

        if (tocPageCunt > 1) {
            for (let i = 0; i < tocPageCunt; i++) {
                doc.movePage(totalPages + i, 2 + i);
            }
        } else {
            doc.movePage(totalPages, 2);
        }

        // doc.movePage(totalPages, 2);
        // doc.movePage(totalPages + 1, 3);

        // Add footer to all pages
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            this.addFooter(doc, pageWidth, pageHeight, i, totalPages);
        }

        return doc;

        //Save the document
        //doc.save('document.pdf');
    }

    public topicSummary(topic: any, level: any, arr: any, showcount: any) {
        let indentSpacing = '';
        for (let i = 0; i < level; i++) {
            indentSpacing += '   ';
        }
        arr.push({
            text: showcount ? topic.text + ': ' + topic.relevantArticle + ' articles' : topic.text,
            numbering: {
                reference: 'my-unique-bullet-points',
                level: level,
            },
            style: 'paragraphIndented1',
        });
        if (topic.children) {
            topic.children.map((item: any) => {
                arr = this.topicSummary(item, level + 1, arr, showcount);
            });
        }
        return arr;
    }

    public topicCardHeadingType(level: any) {
        switch (level) {
            case 0:
                return 'HEADING_1';

            case 1:
                return 'HEADING_2';

            case 2:
                return 'HEADING_3';

            case 3:
                return 'HEADING_4';
        }
        return 'HEADING_5';
    }

    public topicCard(topic: any, allTopicArticles: any, topicLevelMultidocSummary: any, arr: any, level: any, breadcrums: any, type: any, topicType: any): any {
        if (type == 'multi') {
            if (topicType !== 'additional') {
                arr.push(
                    {
                        heading: this.topicCardHeadingType(level),
                        pageBreakBefore: true,
                    },
                    {
                        text: topic.text,
                        style: 'topicHeading',
                    },
                );
            }
        } else {
            arr = this.createTopicHeading(arr, topic, allTopicArticles, level, topicType);
        }
        arr = this.topicArticleCard(topic, allTopicArticles, topicLevelMultidocSummary, arr, level, type, topicType);
        if (topic.children) {
            breadcrums[level] = { topicText: topic.text, topicId: topic.id };
            level = level + 1;
            if (type != 'multi') {
                topic.children.map((childTopic: any) => {
                    arr = this.topicCard(childTopic, allTopicArticles, topicLevelMultidocSummary, arr, level, breadcrums, type, topicType);
                });
            }
        }
        return arr;
    }

    public getTopicType(topic: any, allTopicArticles: any, topicType: any) {
        let addTopic = true;
        if (topicType === 'additional') {
            const topicArticles = allTopicArticles.filter((item: any) => {
                return item.topicId == topic.id;
            });
            const articleLength = topicArticles[0]['paragraphs'].length;
            //console.log('articleLength', articleLength);

            addTopic = articleLength > 10 ? true : false;
        }
        return addTopic;
    }

    public createTopicHeading(arr: any, topic: any, allTopicArticles: any, level: any, topicType: any) {
        const addTopic = this.getTopicType(topic, allTopicArticles, topicType);

        const pageBreakBefore = level > 0 ? false : topicType === 'additional' ? false : true;

        if (addTopic) {
            if (topicType === 'additional') {
                arr.push({
                    text: topic.text,
                    heading: this.topicCardHeadingType(level),
                    pageBreakBefore: pageBreakBefore,
                    style: 'additionalTopicHeading',
                });
            } else {
                arr.push({
                    text: topic.text,
                    style: 'topicHeading',
                });
            }
        }

        return arr;
    }

    public topicArticleCard(topic: any, allTopicArticles: any, topicLevelMultidocSummary: any, arr: any, level: any, type: any, topicType: any): any {
        const topicArticles = allTopicArticles.filter((item: any) => {
            return item.topicId == topic.id;
        });
        if (type === 'multi') {
            // topicArticles = allTopicArticles;
            // const summary = topicArticles[0].contextualSummary.summary;
            // arr = this.topicMultipleArticleCard(topic, summary, arr, type, level, type);
        } else {
            if (topicArticles.length > 0 && topicArticles[0]['paragraphs'].length > 0) {
                arr = this.topicArticle(topic, topicArticles, topicLevelMultidocSummary, arr, level, topicType);
            } else {
                const topicId = topicArticles[0].topicId;
                const multiArticleTopics = topicLevelMultidocSummary.filter((item: any) => item.topicId == topicId);
                if (multiArticleTopics.length > 0 && topicType !== 'additional') {
                    multiArticleTopics[0]['paragraphs'].map((item: any) => {
                        arr = this.addContextualSummary(item, item.contextualSummary.summary, arr, level);
                    });
                }
                if (topicType !== 'additional' && topic.doSearch) {
                    arr.push({
                        text: 'No articles found.',
                        style: 'paragraph1',
                    });
                    // arr.push({
                    //     text: '',
                    //     spacing: {
                    //         after: 200,
                    //     },
                    // });
                }
            }
        }
        return arr;
    }

    public strip_html_tags(str: any) {
        if (str === null || str === '') return false;
        else str = str.toString();
        return str.replace(/<[^>]*>/g, '');
    }

    public topicArticle(topic: any, topicArticles: any, topicLevelMultidocSummary: any, arr: any, level: any, topicType: any): any {
        const topicId = topicArticles[0].topicId;
        const multiArticleTopics = topicLevelMultidocSummary.filter((item: any) => item.topicId == topicId);

        if (multiArticleTopics.length > 0 && topicType !== 'additional') {
            multiArticleTopics[0]['paragraphs'].map((item: any) => {
                arr = this.addContextualSummary(item, item.contextualSummary.summary, arr, level);
            });
        }

        topicArticles[0]['paragraphs'].map((item: any, index: any) => {
            //console.log('topicArticles.topicArticle.length', index);
            if (index <= 9 && topicType !== 'additional') {
                arr = this.addSHeadingArticleCardParent(item, arr, level);
            } else {
                if (topicType === 'additional' && index > 9) {
                    arr = this.addSHeadingArticleCardParent(item, arr, level);
                }
            }
        });

        return arr;
    }

    public addSHeadingArticleCardParent(item: any, arr: any, level: any): any {
        arr = this.addSHeadingArticleCard(item, arr);
        if (item.showSummary && !item.suppressSummary) {
            arr = this.addContextualSummary(item, item.contextualSummary, arr, level);
        } else {
            //arr = this.summaryNotAvaiableArticleCard(arr);
            arr.push({
                text: '',
                style: 'emptyparagraph1',
            });
        }
        return arr;
    }

    public addContextualSummary(item: any, summary: any, arr: any, level: any): any {
        const summaryLength = summary.length;
        summary.map((summaryitem: any) => {
            if (summaryitem.summaryText === item.title) {
                //console.log('addContextualSummary.summary.length', summary.length);
                arr.push({
                    text: '',
                    style: 'emptyparagraph1',
                });
            } else {
                arr = this.addSummaryArticleCard(summaryitem, arr);
            }
            if (summaryitem.nextLevel) {
                arr = this.nestedTopicArticleCard(summaryitem, arr, level + 1);
            }
        });
        if (summaryLength <= 0) {
            arr.push({
                text: '',
                style: 'emptyparagraph1',
            });
        }
        return arr;
    }

    public nestedTopicArticleCard(item: any, arr: any, level: any): any {
        level = level;
        item.children.map((childTopic: any) => {
            if (level > 8) {
                return arr;
            }
            arr.push({
                text: this.strip_html_tags(childTopic.summaryText.trim()),
                numbering: {
                    reference: 'my-unique-bullet-points',
                    level: level,
                },
                style: 'paragraph1',
            });
            // arr.push({
            //     text: '',
            //     spacing: {
            //         after: 200,
            //     },
            // });
            if (childTopic.nextLevel) {
                arr = this.nestedTopicArticleCard(childTopic, arr, level + 1);
            }
        });

        return arr;
    }

    public summaryNotAvaiableArticleCard(arr: any): any {
        // arr.push({
        //     //text: SUMMARYNOTAVAILABLE,
        //     text: '',
        //     style: 'paragraph1',
        // });
        // arr.push({
        //     text: '',
        //     spacing: {
        //         after: 200,
        //     },
        // });

        return arr;
    }

    public addSummaryArticleCard(summaryitem: any, arr: any): any {
        if (summaryitem.summaryText.trim() == 'Summary is not available.' || summaryitem.summaryText.trim() == 'No Summary Available') {
            arr.push({
                text: '',
                style: 'emptyparagraph1',
            });
            return arr;
        }
        arr.push({
            text: this.strip_html_tags(summaryitem.summaryText.trim()),
            style: 'paragraph1',
        });
        // arr.push({
        //     text: '',
        //     spacing: {
        //         after: 200,
        //     },
        // });

        return arr;
    }

    public addSHeadingArticleCard(item: any, arr: any): any {
        // const articleTitle = [];
        // const articleHead1 = [];
        item.url.indexOf('http') > -1;
        if (item.url.indexOf('http') > -1) {
            arr.push({
                link: item.url,
                text: item.title,
                style: 'articleLTitle',
            });
        } else {
            arr.push({
                text: item.title,
                style: 'articleLink',
                bold: false,
                color: '#0000EE',
                underline: {
                    type: 'SINGLE',
                    color: '0000EE',
                },
            });
        }
        if (item.domain != '') {
            arr.push({
                text: item.domain,
                italics: true,
                bold: false,
                break: 1,
                style: 'articleDomain',
            });
        }
        if (item.publishedDate != '') {
            arr.push({
                text: item.publishedDate,
                bold: false,
                break: 1,
                style: 'articleDate',
            });
        }
        //arr.push({ children: articleHead1, style: 'paragraph1', spacing: { after: 20 } });

        return arr;
    }

    public addFirstPageContent(doc: any, gyanSummary: any, pageWidth: any, pageHeight: any) {
        const today = new Date();
        const formattedDate = today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

        // Add gyan logo as image (assuming you have an image URL for the logo)
        doc.addImage(logoImgData, 'SVG', 88, 90, 30, 10); // Adjust the coordinates and dimensions as needed

        // Add gyan title
        doc.setFont(fontName, 'bold');
        doc.setFontSize(14);
        doc.setTextColor(0, 0, 0); // Set text color to blue
        doc.text(gyanSummary.gyanTitle, 105, 108, { align: 'center' }); // Adjust the coordinates as needed

        // Add formatted date
        doc.setFont(fontName, 'normal');
        doc.setFontSize(11);
        doc.setTextColor(0); // Reset text color to black
        doc.text(formattedDate, 105, 115, { align: 'center' }); // Adjust the coordinates as needed
    }

    // Add header
    public addHeader(doc: any, pageWidth: any, pageHeight: any) {
        // Add logo
        doc.addImage(logoImgData, 'SVG', LEFTMARGIN, 10, 30, 10); // Adjust the coordinates and dimensions as needed

        // Add line under logo
        doc.setDrawColor(128, 128, 128);
        doc.setLineWidth(0.1);
        doc.line(LEFTMARGIN, 22, pageWidth - 10, 22); // Adjust coordinates as needed
    }

    // Add footer
    public addFooter(doc: any, pageWidth: any, pageHeight: any, pageNumber: any, totalPages: any) {
        // Add page number
        doc.setFontSize(6);
        doc.text(`${pageNumber}`, pageWidth - 20, pageHeight - 10, { align: 'right' });

        // Add copyright info
        doc.setFontSize(6);
        doc.text('© GyanAI, Inc.  All rights reserved.', LEFTMARGIN, pageHeight - 10);
    }

    // Function to add Table of Contents (TOC) with dynamic data and page numbers
    public addTableOfContents(doc: any, content: any, pageWidth: any, pageHeight: any, headingAnchorPoints: any) {
        const tocEntries: any = [];
        let currentPage = 2;
        let pageCount = 1;

        console.log('addTableOfContents.headingAnchorPoints', headingAnchorPoints);

        this.addNewPage(doc, 30, pageWidth, pageHeight);

        // Iterate through the dynamic data to identify TOC entries
        content.forEach((item: any, index: any) => {
            if (item.style === 'topicHeading') {
                // Add TOC entry
                const tocEntry = { title: item.text, page: currentPage };
                tocEntries.push(tocEntry);
                // eslint-disable-next-line sonarjs/no-collapsible-if
            } else if (item.style === 'paragraph1') {
                // Check if content exceeds page height and update current page
                if (doc.lastAutoTable && doc.lastAutoTable.finalY > pageHeight) {
                    currentPage++;
                }
            }
        });

        // Define TOC title
        doc.setFontSize(14);
        doc.setFont(fontName, 'normal');
        doc.text('Table of Contents', LEFTMARGIN, 30);

        let startY = 30;

        //Add TOC entries to the second page of the PDF
        tocEntries.forEach((entry: any, index: any) => {
            // Calculate y-coordinate for TOC entry
            // let y = 40 + index * 7; // Adjust y-coordinate as needed
            doc.setFontSize(10);
            if (startY > 270) {
                startY = this.addNewPage(doc, startY, pageWidth, pageHeight);
                //y = 40 + 0 * 7;
                pageCount++;
                console.log('New Toc Page Added.pageCount', pageCount);
            }

            startY += 7;

            // Calculate the width of the title text
            const titleWidth = doc.getTextWidth(entry.title);

            // Calculate the width of the dots needed to fill the space
            const dotsWidth = doc.getTextWidth('.');

            // Calculate the width of the page number
            const pageNumWidth = doc.getTextWidth(entry.page.toString());

            // Calculate the total width needed for the title, dots, and page number
            const totalWidth = titleWidth + dotsWidth + pageNumWidth;

            // Calculate the x-coordinate for the title with dots
            const titleX = LEFTMARGIN + 5;

            // Calculate the x-coordinate for the page number
            const pageNumX = pageWidth - 20;

            // Calculate the number of dots needed to fill the space between the title and page number
            const dotsCount = Math.floor((pageNumX - titleX - titleWidth) / dotsWidth) - 5;

            // Create a string of dots to fill the space
            const dots = Array(dotsCount + 1).join('.');

            // if (index == 0) {
            //     titleX = LEFTMARGIN - 5;
            // }

            // Add TOC entry to the PDF with a clickable link
            //const linkY = y; // Vertical position for the link
            const linkPage = headingAnchorPoints[index]; // Page number for the link
            const linkText = entry.title; // Text for the link
            // doc.textWithLink(`${linkText} ${dots} `, titleX, linkY, { url: `#page=${linkPage}` }, null, 'left');
            doc.text(`${linkText} ${dots} `, titleX, startY, null, null, 'left');
            doc.text(`${linkPage}`, pageNumX, startY, null, null, 'right');
        });

        // Update page numbers in TOC entries to match the actual page numbers
        tocEntries.forEach((entry: any, index: any) => {
            entry.page = index + 2; // Start numbering from the second page
        });

        // Return the total number of pages in the document
        return pageCount;
    }

    // Add New Page
    public addNewPage(doc: any, startY: any, pageWidth: any, pageHeight: any) {
        // If content exceeds page height, add new page
        doc.addPage();
        this.addHeader(doc, pageWidth, pageHeight);
        startY = 30; // Reset startY for the new page
        return startY;
    }

    // Add content
    public addContent(doc: any, content: any, pageWidth: any, pageHeight: any, totalPages: any) {
        // Define starting y-coordinate for content
        let startY = 30;
        const headingAnchorPoints: any = [];

        //console.log('addContent.content', content);

        // Iterate over the array and add content to the PDF
        // eslint-disable-next-line sonarjs/cognitive-complexity
        content.forEach((item: any) => {
            // console.log('addContent.item', item);
            // console.log('addContent.startY', startY);
            let itemIdentLevel = 10;

            if (item.pageBreakBefore || startY > 270) {
                startY = this.addNewPage(doc, startY, pageWidth, pageHeight);
                totalPages++;
            }

            // Apply style based on item properties
            this.applyStyle(doc, item, startY);

            itemIdentLevel = this.getItemIdentLevel(doc, item);

            if (item.text == '') {
                startY += 6;
            }

            if (item.text) {
                // Add text content
                //doc.setFontSize(12);
                const textLines = doc.splitTextToSize(item.text, 175);
                this.applyStyle(doc, item, startY);

                if (item.style === 'emptyparagraph1') {
                    console.log('emptyparagraph1');
                    startY += 10;
                }

                textLines.forEach((line: any) => {
                    // Move to the next line
                    if (item.link) {
                        doc.textWithLink(line, itemIdentLevel, startY, { url: item.link });
                    } else {
                        doc.text(line, itemIdentLevel, startY);
                    }

                    //doc.text(line, itemIdentLevel, startY);

                    startY += 6;
                    if (startY > 270) {
                        startY = this.addNewPage(doc, startY, pageWidth, pageHeight);
                        totalPages++;
                    }
                });
            }

            if (item.style === 'topicHeading' || item.style === 'additionalTopicHeading') {
                headingAnchorPoints.push(totalPages);
            }

            if (item.style === 'paragraph1') {
                startY += 5;
            } else if (item.style === 'topicHeading' || item.style === 'additionalTopicHeading') {
                startY += 6;
            } else if (item.style === 'addheadingMain') {
                startY += 6;
            }
        });

        return { totalPages, headingAnchorPoints };
    }

    public applyStyle(doc: any, item: any, startY: any) {
        if (item.style === 'topicHeading') {
            doc.setFont(fontName, 'bold');
            doc.setFontSize(12);
            doc.setTextColor(0, 0, 0); // Black color
        } else if (item.style === 'paragraph1' || item.style === 'articleDate') {
            doc.setFont(fontName, 'normal');
            doc.setFontSize(11);
            doc.setTextColor(0, 0, 0); // Black color
        } else if (item.style === 'addheadingMain') {
            doc.setFont(fontName, 'normal');
            doc.setFontSize(14);
            doc.setTextColor(0, 0, 0); // Black color
            //doc.text(' ', 20, startY);
        } else if (item.style === 'articleLTitle' || item.style === 'articleLink') {
            doc.setFont(fontName, 'normal');
            doc.setFontSize(11);
            doc.setTextColor(0, 0, 255); // Black color
            //doc.text(' ', 20, startY);
        } else if (item.style === 'articleDomain') {
            doc.setFont(fontName, 'italic');
            doc.setFontSize(11);
            doc.setTextColor(0, 0, 0); // Black color
            //doc.text(' ', 20, startY);
        }

        if (item.numbering && item.numbering.reference === 'my-unique-bullet-points') {
            doc.setFont(fontName, 'normal');
            doc.setFontSize(11);
            doc.setTextColor(0, 0, 0); // Black color
        }
    }

    public getItemIdentLevel(doc: any, item: any) {
        let itemIdentLevel = LEFTMARGIN;
        // const itemObj = JSON.parse(item);
        const itemObj = item;
        // console.log('getItemIdentLevel.item.1', itemObj);
        // console.log('getItemIdentLevel.item.numbering.1', itemObj.numbering);
        if (itemObj.numbering && itemObj.numbering.level) {
            //console.log('getItemIdentLevel.level.1', itemObj.numbering.level);
            if (itemObj.numbering.level == 1) {
                itemIdentLevel = 20;
            } else if (itemObj.numbering.level == 2) {
                itemIdentLevel = 25;
            } else if (itemObj.numbering.level == 3) {
                itemIdentLevel = 30;
            } else if (itemObj.numbering.level == 4) {
                itemIdentLevel = 35;
            } else if (itemObj.numbering.level == 5) {
                itemIdentLevel = 40;
            } else if (itemObj.numbering.level >= 6) {
                itemIdentLevel = 45;
            }
        }

        //console.log('getItemIdentLevel.itemIdentLevel.2', itemIdentLevel);

        return itemIdentLevel;
    }
}
